import { Box, Text } from '@chakra-ui/react'
import React, { useEffect, useMemo, useState } from 'react'

interface BigCounterProps {
  value: number
  duration?: number
  label: string
  isPercentage?: boolean
}

const BigCounter = ({
  value,
  duration = 850,
  label,
  isPercentage = false,
}: BigCounterProps) => {
  const [displayValue, setDisplayValue] = useState(0)

  useEffect(() => {
    const startValue = 0
    setDisplayValue(0)

    const startTime = performance.now()
    let frameId: number

    const animate = (currentTime: number) => {
      const elapsed = currentTime - startTime
      const progress = Math.min(elapsed / duration, 1)
      const easedProgress = 1 - Math.pow(1 - progress, 5)
      const currentVal = startValue + (value - startValue) * easedProgress
      setDisplayValue(Math.max(0, currentVal))

      if (progress < 1) {
        frameId = requestAnimationFrame(animate)
      }
    }

    frameId = requestAnimationFrame(animate)

    return () => {
      cancelAnimationFrame(frameId)
    }
  }, [value, duration])

  const displayedNumber = Math.round(displayValue)

  const fontSize = useMemo(() => {
    const length = displayedNumber.toString().length
    if (length <= 5) return '3xl'
    return 'xl'
  }, [displayedNumber])

  const formattedNumber = displayedNumber.toLocaleString()

  return (
    <Box
      textAlign="center"
      h="100%"
      display="flex"
      flexDirection="column"
      justifyContent="center"
    >
      <Text
        fontSize={fontSize}
        fontWeight="bold"
        lineHeight="1.2"
        color="gray.1300"
      >
        {isPercentage ? `${formattedNumber}%` : formattedNumber}
      </Text>
      <Text fontSize="md" color="gray.600" mt={2}>
        {label}
      </Text>
    </Box>
  )
}

export default BigCounter
